import {
  getAgencyExchangeRates,
  getEffectiveExchangeRates,
  upsertAgencyExchangeRate,
  useMarketExchangeRate,
} from '@/api/currency-exchange.api';
import { queryKeys } from '@/queryKeys';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export const useAgencyExchangeRates = () =>
  useQuery({
    queryKey: queryKeys.currency.agencyRates,
    queryFn: getAgencyExchangeRates,
  });

export const useUpsertAgencyExchangeRate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: upsertAgencyExchangeRate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.currency.agencyRates,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.currency.effectiveRatesBase,
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.estimates.all });
    },
  });
};

export const useUseMarketExchangeRate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: useMarketExchangeRate,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.currency.agencyRates,
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.currency.effectiveRatesBase,
      });
      queryClient.invalidateQueries({ queryKey: queryKeys.estimates.all });
    },
  });
};

export const useEffectiveExchangeRates = (date?: Date, enabled = true) =>
  useQuery({
    queryKey: queryKeys.currency.effectiveRates(date),
    queryFn: () => getEffectiveExchangeRates(date),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
